import * as React from 'react';
import { Accordion } from 'semantic-ui-react';
import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';
import toPairs from 'lodash/toPairs';
import fromPairs from 'lodash/fromPairs';

import { addModifiers } from '../../../shared/helpers';

import { Check, TestingStatusProps } from './types';
import { CheckMessage } from './SummaryCheckData';

export const RESULTS = ['PENDING', 'ERROR', 'WARNING', 'FAIL', 'PASS'];

export const groupChecksByResult = (checks: Check[]) => {
  const grouped = groupBy(checks, 'result');
  // Sort results by the order in RESULTS (because the response from API could not in the incorrect order)
  return fromPairs(orderBy(toPairs(grouped), ([result]) => RESULTS.indexOf(result), ['desc']));
};

export const TestingStatus = ({ checks, handleClick, typeCheck, type, tableInfoTypes }: TestingStatusProps) => {
  const checksByResult = React.useMemo(() => groupChecksByResult(checks), [checks]);

  return (
    <Accordion>
      {Object.keys(checksByResult)?.map((result, key) => {
        const handler = () => handleClick(result);

        return (
          checksByResult[result].length > 0 && (
            <div key={key} className={`sumary__testing-checks-${result}`}>
              <Accordion.Title
                active={typeCheck[result]}
                className={`sumary__testing-checks-title sumary__testing-checks-${result}-title`}
                onClick={handler}
              >
                <div> {`${checksByResult[result].length} ${result} `} </div>
                <div className={addModifiers('sumary__testing-checks-icon', typeCheck[result] ? [`${result}-up`] : [`${result}-down`])} />
              </Accordion.Title>
              <Accordion.Content active={typeCheck[result]}>
                <ul className={`sumary__testing-checks-${result}-list`}>
                  {checksByResult[result]?.map((check: any, index: number) => (
                    <li key={index}>
                      <div className="sumary__testing-checks-list">
                        <CheckMessage check={check} stage={type} tableInfoTypes={tableInfoTypes} />
                      </div>
                    </li>
                  ))}
                </ul>
              </Accordion.Content>
            </div>
          )
        );
      })}
    </Accordion>
  );
};
